export type InvoiceStatus = 'draft' | 'sent' | 'paid' | 'overdue' | 'cancelled'
export type DiscountType = 'percent' | 'amount'

export interface LineItem {
  id: number
  invoice_id: number
  description: string
  quantity: string
  unit_price: string
  line_total: string
  sort_order: number
  tax_inclusive: boolean
  discount_type: DiscountType | null
  discount_value: string | null
}

export interface LineItemCreate {
  description: string
  quantity: number | string
  unit_price: number | string
  sort_order?: number
  tax_inclusive?: boolean
  discount_type?: DiscountType | null
  discount_value?: number | string | null
}

export interface LineItemUpdate {
  description?: string
  quantity?: number | string
  unit_price?: number | string
  sort_order?: number
  tax_inclusive?: boolean
  discount_type?: DiscountType | null
  discount_value?: number | string | null
}

export interface SuggestedLineItem {
  description: string
  quantity: string
  unit_price: string
  tax_inclusive: boolean
}

export interface InvoiceListItem {
  id: number
  practice_id: number
  client_id: number
  patient_id: number | null
  invoice_number: string
  status: InvoiceStatus
  issued_date: string
  due_date: string | null
  total_amount: string
  client_name: string | null
  patient_name: string | null
  line_item_count: number
  created_at: string
}

export interface InvoiceDetail {
  id: number
  practice_id: number
  client_id: number
  patient_id: number | null
  consultation_id: number | null
  appointment_id: number | null
  invoice_number: string
  status: InvoiceStatus
  issued_date: string
  due_date: string | null
  paid_at: string | null
  tax_rate: string
  subtotal: string
  tax_amount: string
  total_amount: string
  discount_type: DiscountType | null
  discount_value: string | null
  discount_amount: string
  notes: string | null
  line_items: LineItem[]
  client_name: string | null
  patient_name: string | null
  line_item_count: number
  created_at: string
  updated_at: string
}

export interface InvoiceCreate {
  practice_id: number
  client_id: number
  patient_id?: number | null
  consultation_id?: number | null
  appointment_id?: number | null
  issued_date?: string | null
  due_date?: string | null
  tax_rate?: number | string
  notes?: string | null
  discount_type?: DiscountType | null
  discount_value?: number | string | null
  line_items?: LineItemCreate[]
}

export interface InvoiceUpdate {
  status?: InvoiceStatus
  issued_date?: string
  due_date?: string | null
  paid_at?: string | null
  tax_rate?: number | string
  notes?: string | null
  discount_type?: DiscountType | null
  discount_value?: number | string | null
}

export const STATUS_LABELS: Record<InvoiceStatus, string> = {
  draft:     'Draft',
  sent:      'Sent',
  paid:      'Paid',
  overdue:   'Overdue',
  cancelled: 'Cancelled',
}

export const STATUS_COLORS: Record<InvoiceStatus, { color: string; bg: string }> = {
  draft:     { color: 'var(--text-2)', bg: 'var(--surface-alt)' },
  sent:      { color: 'var(--warning-text)', bg: 'var(--warning-bg)' },
  paid:      { color: 'var(--success-text)', bg: 'var(--success-bg)' },
  overdue:   { color: 'var(--danger-text)', bg: 'var(--danger-bg)' },
  cancelled: { color: 'var(--text-3)', bg: 'var(--surface-alt)' },
}
